
@if (options.label) {
  <label class="label-above" (click)="onClickSetFocus()">
    {{ options.label | translate }}
  </label>
}
@if (options.caption) {
  <p class="caption grey">{{ options.caption | translate }}</p>
}
<div class="contenteditable-wrapper">
  <div
    [id]="options.id"
    class="chip-text-area"
    #textarea
    contenteditable="plaintext-only"
    role="textbox"
    aria-multiline="true"
    spellcheck="false"
    [class.no-resize]="options.noResize"
    [class.text-input]="options.asTextInput"
    [class.invalid]="invalid"
    (keydown)="onKeypressEvent($event)"
    (input)="onInput()"
    (click)="onClick()"
    (blur)="onBlur()">
  </div>
</div>